import {ZeroBet} from "@nolimitcity/slot-game/bin/timelinegameround/game/gameround/presentations/ZeroBet";
import {TimelineLite} from "gsap";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenGameMode} from "../gameMode/TombOfAkhenatenGameMode";
import {TombOfAkhenaten} from "../TombOfAkhenaten";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export interface IPlayerInteraction {
    selectedIndex:string
}

export class TombOfAkhenatenZeroBet extends ZeroBet {

    getAnimation(data:TombOfAkhenatenParsedGameData):gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax {
        const tl:TimelineLite = new TimelineLite();
        let fsLeft:number = -1;

        if(data.nextMode === TombOfAkhenatenGameMode.FREESPIN){
            fsLeft = data.freespinsLeft - 1;
        }else if(data.nextMode.indexOf("FS") > -1){
            //413
            //fsLeft = data.freespinsLeft + TombOfAkhenatenReelController.SCATTER_COUNT;
            let stickySyms: string[] = data.stickySymbols.reduce(function(a, v, i) { if (v[0]==="S") a.push(i.toString()); return a; }, []);
            fsLeft = data.freespinsLeft + stickySyms.length;
        }

        tl.add(() => {
            TombOfAkhenaten.api.betHandler.zeroBet();
            TombOfAkhenaten.keypad.setZeroBetSpinCounter(fsLeft);
            fsLeft != -1 && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_SPINS_LEFT_METER, fsLeft));
        });

        return tl;
    }
}